import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "./formGroup";

interface FormFileProps extends Controls.ControlFileProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
}

const ComponentProps = (props: FormFileProps): Controls.ControlFileProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormFileProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormFile: React.FC<Controls.ControlFileProps> = (props) => {
    const styles: IFormStyles = useFormStyles();
    
    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlFile {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};